import { render, staticRenderFns } from "./DashboardOwner.vue?vue&type=template&id=32d2fec1&scoped=true"
import script from "./DashboardOwner.vue?vue&type=script&lang=js"
export * from "./DashboardOwner.vue?vue&type=script&lang=js"
import style0 from "./DashboardOwner.vue?vue&type=style&index=0&id=32d2fec1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32d2fec1",
  null
  
)

export default component.exports